import React from "react";

import "./Logo.css";

function Logo() {
    return (
        <p className="logo">
            Ju<span className="logo-x">x</span>tapose
        </p>
    )
}

export default Logo;
